module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"RedirectModal":{"button":"Přejít na B2B e-shop","heading":"Máme připravený nový B2B e-shop.","text":"Kliknutím na tlačítko níže na něj přejdete."}}}')
  delete Component.options._Ctor
}
